var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3622 16.6122L12.4872 8.4872C12.5627 8.41166 12.6523 8.35173 12.7509 8.31084C12.8495 8.26995 12.9553 8.24891 13.062 8.24891C13.1688 8.24891 13.2746 8.26995 13.3732 8.31084C13.4718 8.35173 13.5614 8.41166 13.6369 8.4872L21.7619 16.6122C21.9144 16.7647 22 16.9714 22 17.187C22 17.4027 21.9144 17.6094 21.7619 17.7619C21.6094 17.9144 21.4027 18 21.187 18C20.9714 18 20.7647 17.9144 20.6122 17.7619L13.062 10.2107L5.51189 17.7619C5.4364 17.8374 5.34678 17.8973 5.24815 17.9381C5.14952 17.979 5.0438 18 4.93705 18C4.83029 18 4.72458 17.979 4.62594 17.9381C4.52731 17.8973 4.43769 17.8374 4.3622 17.7619C4.28671 17.6864 4.22683 17.5968 4.18598 17.4981C4.14512 17.3995 4.12409 17.2938 4.12409 17.187C4.12409 17.0803 4.14512 16.9746 4.18598 16.8759C4.22683 16.7773 4.28671 16.6877 4.3622 16.6122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpWhite);
export default __webpack_public_path__ + "static/media/arrow-up-white.a6aa6dd542390af052a75c46fecfeff3.svg";
export { ForwardRef as ReactComponent };